import React from 'react';

import { translations } from 'i18n';
import { GalleryAppPermissions } from './types';
import { ToggleList } from '../Toggle/ToggleList';

interface PermissionListProps {
  itemComponent: React.FunctionComponent<any>;
  newPermissions: string[];
  onChange: (...args: any) => void;
  permissionAlerts?: any;
  permissions: GalleryAppPermissions;
  visiblePermissions: string[];
  containerComponent: React.FunctionComponent;
}

export default class PermissionList extends React.Component<PermissionListProps> {

  static defaultProps = {
    newPermissions: [],
    permissionAlerts: {}
  };

  onChange = async (...args: any) => this.props.onChange(...args);

  renderItem = (itemProps: any) => {
    const { itemComponent: ItemComponent } = this.props;

    return <ItemComponent {...itemProps} />;
  };

  render() {
    const {
      containerComponent,
      newPermissions,
      visiblePermissions,
      permissions,
      permissionAlerts
    } = this.props;
    const {
      comms: { permissions: permissionsText }
    } = translations;

    const items = visiblePermissions.map((permission) => ({
      description: permissionsText[permission].description(),
      isNew: newPermissions.includes(permission),
      showWarning: !!permissionAlerts[permission],
      title: permissionsText[permission].label(),
      value: permission,
      id: `toggle-${permission}`,
    }));

    return (
      <ToggleList
        containerComponent={containerComponent}
        items={items}
        onChange={this.onChange}
        renderItem={this.renderItem}
        valueToggles={permissions}
      />
    );
  }
}
